import React from "react";
import { Link, useParams } from "react-router-dom";
import NoAccess from "../NoAccess";
import { useUser } from "../../context/UserContext";
import { getRoleNames, hasAnyPermission } from "../../utils/tenantAdminAccess";
import { findIntegrationBySlug } from "./integrationCatalog";

function canAccessIntegrationDetail(integration, user) {
  const roleNames = new Set(getRoleNames(user));
  if (roleNames.has("tenantadmin") || roleNames.has("platformadmin")) {
    return true;
  }

  if (!roleNames.has("projectleider")) {
    return false;
  }

  if (!Array.isArray(integration?.permissionsAny) || integration.permissionsAny.length === 0) {
    return true;
  }

  return hasAnyPermission(user, integration.permissionsAny);
}

export default function TenantAdminIntegrationDetailPage() {
  const { integrationKey } = useParams();
  const { user } = useUser();
  const integration = findIntegrationBySlug(integrationKey);

  if (!integration) {
    return (
      <div className="min-h-screen bg-slate-50 p-4 md:p-6">
        <div className="mx-auto max-w-6xl rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
          <h1 className="text-2xl font-bold text-slate-900">Integratie niet gevonden</h1>
          <p className="mt-2 text-sm text-slate-600">
            De opgegeven integratie bestaat niet binnen deze beheeromgeving.
          </p>
          <Link to="/tenant-admin/integrations" className="mt-4 inline-block text-sm text-slate-700 underline">
            Terug naar integraties
          </Link>
        </div>
      </div>
    );
  }

  if (!canAccessIntegrationDetail(integration, user)) {
    const roleNames = getRoleNames(user);
    const visibleRole = roleNames[0] || user?.rol || user?.role || "";
    return (
      <NoAccess
        allowedRoles={["TenantAdmin", "Projectleider (met integratie-rechten)"]}
        currentRole={visibleRole}
        requiredRoles={["TenantAdmin", "Projectleider (met integratie-rechten)"]}
        userRole={visibleRole}
      />
    );
  }

  return (
    <div className="min-h-screen bg-slate-50 p-4 md:p-6">
      <div className="mx-auto max-w-6xl">
        <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
          <div>
            <h1 className="text-2xl font-bold text-slate-900">{integration.title}</h1>
            <p className="text-sm text-slate-600">{integration.description}</p>
          </div>
          <div className="flex flex-wrap gap-2">
            <Link
              to="/tenant-admin/integrations"
              className="rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-700 hover:bg-slate-50"
            >
              Terug naar integraties
            </Link>
            <Link
              to="/tenant-admin"
              className="rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-700 hover:bg-slate-50"
            >
              Terug naar hub
            </Link>
          </div>
        </div>

        <div className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
          <p className="text-sm text-slate-700">
            Dit is een placeholder-detailpagina. In de volgende iteratie koppelen we hier de concrete
            integratie- en outputinstellingen.
          </p>
        </div>
      </div>
    </div>
  );
}
